"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = capitalize;
function capitalize(str) {
    const firstLetter = str[0].toUpperCase();
    const word = str.slice(1);
    return `${firstLetter}${word}`;
}
//# sourceMappingURL=lib.js.map